/* eslint-disable react/no-array-index-key, jsx-a11y/heading-has-content */
import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ReactAux, Section, FileUploadHistoryCard } from '@jkhy/vsg-design-system';

import { Base, BaseType as BaseType_ } from '../common/base-component';
import { AppState as AppState_ } from '../../redux/app-state';
import RequiredDocument_, { HistoryDocument as HistoryDocument_ } from '../../data/models/RequiredDocumet';
import { getRequiredDocumentsHistory as getRequiredDocumentsHistory_ } from '../../redux/actions/doc-actions';
import Grid, { Column as Column_ } from '../common/grid/grid';
import { formatDate } from '../../utils/helper';
import PublicContent from '../../data/models/PublicContent';
import { AppDispatch } from '../../data/models/AppDispatch';
import '../../../css/default.css';

export const PageDataUI = 'RequiredDocumentsHistory';

type RequiredDocumentsHistoryProps = {
  documents: RequiredDocument_[],
  getRequiredDocumentsHistory: () => Promise<any>
} & BaseType_

export class RequiredDocumentsHistory extends Base<RequiredDocumentsHistoryProps, {}> {
  async componentDidMount() {
    const { getRequiredDocumentsHistory, } = this.props;

    await getRequiredDocumentsHistory();
  }

  columns: Array<Column_> = [{
    field: 'dateUpdated',
    title: 'Date:',
    cell: (cellValue) => {
      // item.status === WebDocumentStatus.Uploaded ? item?.dateUpdated : item?.dateCreated
      return formatDate(cellValue);
    },
    dataUI: 'date',
  },
  {
    field: 'message',
    title: 'Action:',
    dataUI: 'action',
  },
  {
    field: 'rejectReason',
    title: 'Description:',
    dataUI: 'description',
  }];

  renderHistory = (historyList: HistoryDocument_[], index: number) => {
    return (
      <Grid columns={this.columns} data={historyList} dataUI={`RequiredDocumentsHistoryWrapper${index}`} className="history-table-wrapper" />
    );
  };

  getDocumentDetails = (document: RequiredDocument_) => {
    const {
      requiredFor,
      statementDate,
      hideStatementDate,
      // hideDueDate,
      // dueDate
    } = document;

    const details = [{
      title: 'Required for:',
      text: requiredFor.replace(/&#(\d+);/g, (_, dec) => String.fromCharCode(dec)),
      dataUI: 'RequiredDocumentsHistoryRequiredFor',
    }];

    if (statementDate && !hideStatementDate) {
      details.push({
        title: 'Statement Date:',
        text: formatDate(statementDate),
        dataUI: 'RequiredDocumentsHistoryStatementDate',
      });
    }

    // TODO: future enhancment
    // if (dueDate && !hideDueDate) {
    // details.push({
    //   title: 'Due:',
    //   text: moment(dueDate).format('MM/DD/YYYY'),
    //   dataUI: 'RequiredDocumentsHistoryDueDate',
    // });
    // }

    return details;
  }

  getDocumentDescription = (document: RequiredDocument_) => {
    const { portalDescription, documentDescription, hideDescription, } = document;
    const description = portalDescription || documentDescription;

    return description && !hideDescription
      ? { title: 'Description:', text: description, }
      : null;
  }

  content = () => {
    const { documents, } = this.props;
    let dataUICounter = 0;

    const { requestDocsHistoryPageTitle, requestDocsHistoryPageDescription, } = window?.PublicContent ?? new PublicContent();

    return (
      <ReactAux>
        <Section dataUI={PageDataUI}>
          <h1 data-ui={`${PageDataUI}-page-title`} className="mb-2 text-preline break-word">{requestDocsHistoryPageTitle}</h1>
          <p data-ui={`${PageDataUI}-page-description`} className="mb-3 text-preline break-word">{requestDocsHistoryPageDescription}</p>

          {documents?.map((doc: RequiredDocument_, i: number) => {
            if (doc?.historyList?.length > 0) {
              dataUICounter = dataUICounter + 1;
              const title = doc?.portalDocumentName || doc?.documentType;
              const key = `${doc?.id}-${title}-${i}`;

              const description = this.getDocumentDescription(doc);

              return (
                <FileUploadHistoryCard
                  key={key}
                  className="mb-2"
                  title={title}
                  description={description}
                  details={this.getDocumentDetails(doc)}
                  dataUI={`RequiredDocumentsHistoryCard${dataUICounter}`}
                >
                  {this.renderHistory(doc?.historyList, dataUICounter)}
                </FileUploadHistoryCard>
              );
            }

            return null;
          })}

        </Section>
      </ReactAux>
    );
  }
}

export default withRouter(connect(
  (state: AppState_) => ({
    documents: state.docHistories,
  }),
  (dispatch: AppDispatch) => {
    return {
      getRequiredDocumentsHistory: () => dispatch(getRequiredDocumentsHistory_()),
    };
  }
)(RequiredDocumentsHistory));
